module.exports = __webpack_public_path__ + "static/img/ME 2025_BG only.28bc6c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ME 2025_BG only.jpg
// module id = x9Ab
// module chunks = 1